import React from 'react';
import { Table } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import {
	QUES_CODE_PREFIX,
	formatBrsrNumericCellValue,
	getFormattedTextEmbeddedinLITag,
	renderQuestionAnswer
} from '../../../../core/utilities/BRSRUtils';
import './../Reporting.scss';

const BRSRPrinciple3 = ({
	t,
	page5,
	yearFilter
}) => {


	const renderP3Q1 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page5?.['previousYear']) {
			page5['previousYear'][QUES_CODE_PREFIX + 'P3-1']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>1.</b>
				<b>a. Details of measures for the well-being of employees:</b>
				<div className="mt-2 mb-2">
					<Table responsive bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th rowSpan="3">Category</th>
								<th colSpan="11" className="text-center font-color">% of employees covered by</th>
							</tr>
							<tr>
								<th rowSpan="2">Total (A)</th>
								<th colSpan="2" className="text-center">Health insurance</th>
								<th colSpan="2" className="text-center">Accident insurance</th>
								<th colSpan="2" className="text-center">Maternity benefits</th>
								<th colSpan="2" className="text-center">Paternity Benefits</th>
								<th colSpan="2" className="text-center">Day Care facilities</th>
							</tr>
							<tr>
								<th>Number (B)</th>
								<th>% (B/A)</th>
								<th>Number (C)</th>
								<th>% (C/A)</th>
								<th>Number (D)</th>
								<th>% (D/A)</th>
								<th>Number (E)</th>
								<th>% (E/A)</th>
								<th>Number (F)</th>
								<th>% (F/A)</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan="12" className="text-center font-color"><strong>Permanent employees</strong> </td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a1a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a1b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a1c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a1d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a1e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a1f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a1g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a1h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a1i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a1j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a1k'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a2a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a2b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a2c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a2d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a2e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a2f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a2g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a2h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a2i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a2j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a2k'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total</strong></td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a3a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a3b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a3c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a3d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a3e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a3f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a3g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a3h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a3i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a3j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a3k'] ?? ''}</td>
							</tr>
							<tr>
								<td colSpan="12" className="text-center font-color"><strong>Other than Permanent employees</strong> </td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a4a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a4b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a4c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a4d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a4e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a4f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a4g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a4h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a4i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a4j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a4k'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a5a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a5b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a5c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a5d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a5e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a5f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a5g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a5h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a5i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a5j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a5k'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total</strong></td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a6a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a6b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a6c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a6d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a6e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a6f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a6g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a6h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a6i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a6j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1a6k'] ?? ''}</td>
							</tr>
							
						</tbody>
					</Table>
				</div>
				<div>
					<b>b. Details of measures for the well-being of workers:</b>
				</div>
				<div className="mt-2 mb-2">
					<Table responsive bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th rowSpan="3">Category</th>
								<th colSpan="11" className="text-center font-color">% of workers covered by</th>
							</tr>
							<tr>
								<th rowSpan="2">Total (A)</th>
								<th colSpan="2" className="text-center">Health insurance</th>
								<th colSpan="2" className="text-center">Accident insurance</th>
								<th colSpan="2" className="text-center">Maternity benefits</th>
								<th colSpan="2" className="text-center">Paternity Benefits</th>
								<th colSpan="2" className="text-center">Day Care facilities</th>
							</tr>
							<tr>
								<th>Number (B)</th>
								<th>% (B/A)</th>
								<th>Number (C)</th>
								<th>% (C/A)</th>
								<th>Number (D)</th>
								<th>% (D/A)</th>
								<th>Number (E)</th>
								<th>% (E/A)</th>
								<th>Number (F)</th>
								<th>% (F/A)</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan="12" className="text-center font-color"><strong>Permanent workers</strong> </td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b1a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b1b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b1c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b1d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b1e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b1f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b1g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b1h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b1i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b1j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b1k'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b2a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b2b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b2c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b2d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b2e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b2f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b2g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b2h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b2i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b2j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b2k'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total</strong></td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b3a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b3b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b3c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b3d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b3e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b3f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b3g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b3h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b3i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b3j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b3k'] ?? ''}</td>
							</tr>
							<tr>
								<td colSpan="12" className="text-center font-color"><strong>Other than Permanent workers</strong> </td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b4a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b4b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b4c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b4d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b4e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b4f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b4g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b4h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b4i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b4j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b4k'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b5a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b5b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b5c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b5d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b5e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b5f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b5g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b5h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b5i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b5j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b5k'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total</strong></td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b6a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b6b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b6c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b6d'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b6e'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b6f'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b6g'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b6h'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b6i'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b6j'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1b6k'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
				<div>
					<b>c. Spending on measures towards well-being of employees and workers (including permanent and other than permanent) in the following format –</b>
				</div>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th className='FY_class white-nowrap'>FY {yearFilter}</th>
								<th className='white-nowrap'>FY {yearFilter - 1}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Cost incurred on well-being measures as a % of total revenue  of the company</td>
								<td className='FY_class_content'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-1c'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-1c'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP3Q2 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page5?.['previousYear']) {
			page5['previousYear'][QUES_CODE_PREFIX + 'P3-2']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>2. Details of retirement benefits, for Current FY and {yearFilter - 1}.</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan="2">Benefits</th>
								<th colSpan="3" className="text-center FY_class white-nowrap">FY {yearFilter}</th>
								<th colSpan="3" className="text-center white-nowrap">FY {yearFilter - 1}</th>
							</tr>
							<tr>
								<th className='FY_class_sub'>No. of employees covered as a % of total employees</th>
								<th className='FY_class_sub'>No. of workers covered as a % of total workers</th>
								<th className='FY_class_sub'>Deducted and deposited with the authority (Y/N/N.A.)</th>
								<th>No. of employees covered as a % of total employees</th>
								<th>No. of workers covered as a % of total workers</th>
								<th>Deducted and deposited with the authority (Y/N/N.A.)</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>PF</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2aa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2ab'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2ac'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2aa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2ab'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2ac'] ?? ''}</td>
							</tr>
							<tr>
								<td>Gratuity</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2ba'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2bb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2bc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2ba'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2bb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2bc'] ?? ''}</td>
							</tr>
							<tr>
								<td>ESI</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2ca'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2cb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2cc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2ca'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2cb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2cc'] ?? ''}</td>
							</tr>
							<tr>
								<td>Others – please specify</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2da'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2db'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-2dc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2da'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2db'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-2dc'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP3Q3 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('3. Accessibility of workplaces - Are the premises / offices of the entity accessible to differently abled employees and workers, as per the requirements of the Rights of Persons with Disabilities Act, 2016? If not, whether any steps are being taken by the entity in this regard.', currentYearAnswer[QUES_CODE_PREFIX + 'P3-3a'] ?? '');
	};

	const renderP3Q4 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-4']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('4. Does the entity have an equal opportunity policy as per the Rights of Persons with Disabilities Act, 2016? If so, provide a web-link to the policy', currentYearAnswer[QUES_CODE_PREFIX + 'P3-4a'] ?? '');
	};

	const renderP3Q5 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-5']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>5. Return to work and Retention rates of permanent employees and workers that took parental leave.</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th colSpan="2" className="text-center">Permanent employees</th>
								<th colSpan="2" className="text-center">Permanent workers</th>
							</tr>
							<tr>
								<th>Gender</th>
								<th>Return to work rate</th>
								<th>Retention rate</th>
								<th>Return to work rate</th>
								<th>Retention rate</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Male</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5aa'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5ab'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5ac'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5ad'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5ba'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5bb'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5bc'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5bd'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total</strong></td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5ca'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5cb'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5cc'] ?? ''}</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-5cd'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP3Q6 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-6']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>6. Is there a mechanism available to receive and redress grievances for the following categories of employees and worker? If yes, give details of the mechanism in brief</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th>Yes/No (If Yes, then give details of the mechanism in brief)</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Permanent Workers</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-6a'] ?? ''}</td>
							</tr>
							<tr>
								<td>Other than Permanent Workers</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-6b'] ?? ''}</td>
							</tr>
							<tr>
								<td>Permanent Employees</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-6c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Other than Permanent Employees</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-6d'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP3Q7 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-7']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page5?.['previousYear']) {
			page5['previousYear'][QUES_CODE_PREFIX + 'P3-7']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>7. Membership of employees and worker in association(s) or Unions recognised by the listed entity:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan="2">Category</th>
								<th colSpan="3" className="text-center FY_class">FY ({yearFilter})</th>
								<th colSpan="3" className="text-center">FY ({yearFilter - 1})</th>
							</tr>
							<tr>
								<th className='FY_class_sub'>Total employees / workers in respective category (A)</th>
								<th className='FY_class_sub'>No. of employees / workers in respective category, who are part of association(s) or Union (B)</th>
								<th className='FY_class_sub'> % (B/A)</th>
								<th>Total employees / workers in respective category (C)</th>
								<th>No. of employees / workers in respective category, who are part of association(s) or Union (D)</th>
								<th>% (D/C)</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan={7} className="text-center font-color" ><strong>Total Permanent Employees</strong></td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7aa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7ab'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7ac'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7aa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7ab'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7ac'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7ba'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7bb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7bc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7ba'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7bb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7bc'] ?? ''}</td>
							</tr>
							<tr>
								<td colSpan={7} className="text-center font-color" ><strong>Total Permanent Workers</strong></td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7ca'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7cb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7cc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7ca'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7cb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7cc'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7da'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7db'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-7dc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7da'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7db'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-7dc'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP3Q8 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-8']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page5?.['previousYear']) {
			page5['previousYear'][QUES_CODE_PREFIX + 'P3-8']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>8. Details of training given to employees and workers:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan={3}>Category</th>
								<th colSpan={5} className="text-center FY_class white-nowrap">FY {yearFilter}</th>
								<th colSpan={5} className="text-center white-nowrap">FY {yearFilter - 1}</th>
							</tr>
							<tr>
								<th rowSpan={2} className='FY_class_sub'>Total (A)</th>
								<th colSpan={2} className='FY_class_sub'>On Health and safety measures</th>
								<th colSpan={2} className='FY_class_sub'>On Skill upgradation</th>
								<th rowSpan={2}>Total (D)</th>
								<th colSpan={2}>On Health and safety measures</th>
								<th colSpan={2}>On Skill upgradation</th>
							</tr>
							<tr>
								<th className='FY_class_sub'>No. (B)</th>
								<th className='FY_class_sub'>% (B/A)</th>
								<th className='FY_class_sub'>No. (C)</th>
								<th className='FY_class_sub'>% (C/A)</th>
								<th>No. (E)</th>
								<th>% (E/D)</th>
								<th>No. (F)</th>
								<th>% (F/D)</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan={11} className="text-center font-color"><strong>Employees</strong></td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8aa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8ab'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8ac'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8ad'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8ae'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8aa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8ab'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8ac'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8ad'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8ae'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8ba'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8bb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8bc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8bd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8be'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8ba'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8bb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8bc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8bd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8be'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8ca'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8cb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8cc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8cd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8ce'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8ca'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8cb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8cc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8cd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8ce'] ?? ''}</td>
							</tr>
							<tr>
								<td colSpan={11} className="text-center font-color"><strong>Workers</strong></td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8da'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8db'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8dc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8dd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8de'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8da'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8db'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8dc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8dd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8de'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8ea'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8eb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8ec'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8ed'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8ee'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8ea'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8eb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8ec'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8ed'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8ee'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8fa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8fb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8fc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8fd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-8fe'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8fa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8fb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8fc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8fd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-8fe'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP3Q9 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-9']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page5?.['previousYear']) {
			page5['previousYear'][QUES_CODE_PREFIX + 'P3-9']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>9. Details of performance and career development reviews of employees and worker:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan={3}>Category</th>
								<th colSpan={3} className="text-center FY_class white-nowrap">FY {yearFilter}</th>
								<th colSpan={3} className="text-center white-nowrap">FY {yearFilter - 1}</th>
							</tr>
							<tr>
								<th className='FY_class_sub'>Total (A)</th>
								<th className='FY_class_sub'>No. (B)</th>
								<th className='FY_class_sub'>% (B/A)</th>
								<th>Total (C)</th>
								<th>No. (D)</th>
								<th>% (D/C)</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan={7} className="text-center font-color"><strong>Employees</strong></td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9aa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9ab'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9ac'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9aa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9ab'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9ac'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9ba'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9bb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9bc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9ba'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9bb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9bc'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9ca'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9cb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9cc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9ca'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9cb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9cc'] ?? ''}</td>
							</tr>
							<tr>
								<td colSpan={7} className="text-center font-color"><strong>Workers</strong></td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9da'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9db'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9dc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9da'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9db'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9dc'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9ea'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9eb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9ec'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9ea'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9eb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9ec'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Total</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9fa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9fb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-9fc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9fa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9fb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-9fc'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP3Q10 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-10']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>10. Health and safety management system:</b>
				{renderQuestionAnswer('a. Whether an occupational health and safety management system has been implemented by the entity? (Yes/ No). If yes, the coverage such system?', currentYearAnswer[QUES_CODE_PREFIX + 'P3-10a'] ?? '')}
				{renderQuestionAnswer('b. What are the processes used to identify work-related hazards and assess risks on a routine and non-routine basis by the entity?', currentYearAnswer[QUES_CODE_PREFIX + 'P3-10b'] ?? '')}
				{renderQuestionAnswer('c. Whether you have processes for workers to report the work related hazards and to remove themselves from such risks. (Y/N)', currentYearAnswer[QUES_CODE_PREFIX + 'P3-10c'] ?? '')}
				{renderQuestionAnswer('d. Do the employees/ worker of the entity have access to non-occupational medical and healthcare services? (Yes/ No)', currentYearAnswer[QUES_CODE_PREFIX + 'P3-10d'] ?? '')}
			</div>
		);
	};

	const renderP3Q11 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-11']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page5?.['previousYear']) {
			page5['previousYear'][QUES_CODE_PREFIX + 'P3-11']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>11. Details of safety related incidents, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th>Safety Incident/Number</th>
								<th>Category</th>
								<th className="text-center FY_class white-nowrap">FY {yearFilter}</th>
								<th className="text-center white-nowrap">FY {yearFilter - 1}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td rowSpan={2}>Lost Time Injury Frequency Rate (LTIFR) (per one million-person hours worked)</td>
								<td>Employees</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-11a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-11a'] ?? ''}</td>
							</tr>
							<tr>
								<td>Workers</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-11b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-11b'] ?? ''}</td>
							</tr>
							<tr>
								<td rowSpan={2}>Total recordable work-related injuries</td>
								<td>Employees</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-11c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-11c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Workers</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-11d'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-11d'] ?? ''}</td>
							</tr>
							<tr>
								<td rowSpan={2}>No. of fatalities</td>
								<td>Employees</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-11e'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-11e'] ?? ''}</td>
							</tr>
							<tr>
								<td>Workers</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-11f'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-11f'] ?? ''}</td>
							</tr>
							<tr>
								<td rowSpan={2}>High consequence work-related injury or ill-health (excluding fatalities)</td>
								<td>Employees</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-11g'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-11g'] ?? ''}</td>
							</tr>
							<tr>
								<td>Workers</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-11h'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-11h'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
					<small className='italic'>*Including in the contract workforce</small>
				</div>
			</div>
		);
	};

	const renderP3Q12 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-12']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('12. Describe the measures taken by the entity to ensure a safe and healthy work place.', currentYearAnswer[QUES_CODE_PREFIX + 'P3-12a'] ?? '');
	};

	const renderP3Q13 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-13']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page5?.['previousYear']) {
			page5['previousYear'][QUES_CODE_PREFIX + 'P3-13']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>13. Number of Complaints on the following made by employees and workers:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan={2}></th>
								<th colSpan={3} className='FY_class white-nowrap'>FY {yearFilter}</th>
								<th colSpan={3} className='white-nowrap'>FY {yearFilter - 1}</th>
							</tr>
							<tr>
								<th className='FY_class_sub'>Filed during the year</th>
								<th className='FY_class_sub'>Pending resolution at the end of year</th>
								<th className='FY_class_sub'>Remarks</th>
								<th>Filed during the year</th>
								<th>Pending resolution at the end of year</th>
								<th>Remarks</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Working Conditions</td>
								<td className='FY_class_content'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-13aa'] ?? ''}</td>
								<td className='FY_class_content'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-13ab'] ?? ''}</td>
								<td className='FY_class_content'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-13ac'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-13aa'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-13ab'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-13ac'] ?? ''}</td>
							</tr>
							<tr>
								<td>Health & Safety</td>
								<td className='FY_class_content'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-13ba'] ?? ''}</td>
								<td className='FY_class_content'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-13bb'] ?? ''}</td>
								<td className='FY_class_content'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-13bc'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-13ba'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-13bb'] ?? ''}</td>
								<td>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-13bc'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP3Q14 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-14']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>14. Assessments for the year</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th>% of your plants and offices that were assessed (by entity or statutory authorities or third parties)</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Health and safety practices</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-14a'] ?? ''}</td>
							</tr>
							<tr>
								<td>Working Conditions</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-14b'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP3Q15 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-15']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('15. Provide details of any corrective action taken or underway to address safety-related incidents (if any) and on significant risks / concerns arising from assessments of health & safety practices and working conditions', currentYearAnswer[QUES_CODE_PREFIX + 'P3-15a'] ?? '');
	};

	const renderP3LI1 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-LI1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('1. Does the entity extend any life insurance or any compensatory package in the event of death of (A) Employees (Y/N) (B) Workers (Y/N).', currentYearAnswer[QUES_CODE_PREFIX + 'P3-LI1a'] ?? '');
	};

	const renderP3LI2 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-LI2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('2. Provide the measures undertaken by the entity to ensure that statutory dues have been deducted and deposited by the value chain partners.', currentYearAnswer[QUES_CODE_PREFIX + 'P3-LI2a'] ?? '');
	};

	const renderP3LI3 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-LI3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page5?.['previousYear']) {
			page5['previousYear'][QUES_CODE_PREFIX + 'P3-LI3']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>3. Provide the number of employees / workers having suffered high consequence work- related injury / ill-health / fatalities (as reported in Q11 of Essential Indicators above), who have been are rehabilitated and placed in suitable employment or whose family members have been placed in suitable employment:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan={2}></th>
								<th colSpan={2}>Total no. of affected employees/ workers</th>
								<th colSpan={2}>No. of employees/workers that are rehabilitated and placed in suitable employment or whose family members have been placed in suitable employment</th>
							</tr>
							<tr>
								<th className='FY_class'>FY ({yearFilter})</th>
								<th>FY ({yearFilter - 1})</th>
								<th className='FY_class'>FY ({yearFilter})</th>
								<th>FY ({yearFilter - 1})</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Employees</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-LI3aa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-LI3aa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-LI3ab'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-LI3ab'] ?? ''}</td>
							</tr>
							<tr>
								<td>Workers</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-LI3ba'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-LI3ba'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-LI3bb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P3-LI3bb'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP3LI4 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-LI4']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('4. Does the entity provide transition assistance programs to facilitate continued employability and the management of career endings resulting from retirement or termination of employment? (Yes/ No)', currentYearAnswer[QUES_CODE_PREFIX + 'P3-LI4a'] ?? '');
	};

	const renderP3LI5 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-LI5']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>5. Details on assessment of value chain partners:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th>% of value chain partners (by value of business done with such partners) that were assessed</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Health and safety practices</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-LI5a'] ?? ''}</td>
							</tr>
							<tr>
								<td>Working Conditions</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P3-LI5b'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP3LI6 = () => {
		const currentYearAnswer = {};
		if (page5?.['currentYear']) {
			page5['currentYear'][QUES_CODE_PREFIX + 'P3-LI6']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return renderQuestionAnswer('6. Provide details of any corrective actions taken or underway to address significant risks / concerns arising from assessments of health and safety practices and working conditions of value chain partners.', currentYearAnswer[QUES_CODE_PREFIX + 'P3-LI6a'] ?? '');
	};

	return (
		<section id="PRINCIPLE_3" className="Main_Section PRINCIPLE_3">
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 1">
					<div className="ETA_card_Section_head mb-3">
						<h5>PRINCIPLE 3 Businesses should respect and promote the well-being of all employees, including those in their value chains</h5>
					</div>
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head mb-3">
								<b>Essential Indicators</b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP3Q1()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 2">
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP3Q2()}
									{renderP3Q3()}
									{renderP3Q4()}
									{renderP3Q5()}
									{renderP3Q6()}
									{renderP3Q7()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 3">
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP3Q8()}
									{renderP3Q9()}
									{renderP3Q10()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 4">
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP3Q11()}
									{renderP3Q12()}
									{renderP3Q13()}
									{renderP3Q14()}
									{renderP3Q15()}
								</div>
							</div>
						</section>
					</div>
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head mb-3">
								<b>Leadership Indicators</b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP3LI1()}
									{renderP3LI2()}
									{renderP3LI3()}
									{renderP3LI4()}
									{renderP3LI5()}
									{renderP3LI6()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</section>
	);
};

export default withTranslation()(BRSRPrinciple3);
